import React from 'react';
import { AudiencesOpeners } from '../../components';

const APPS = [
  {
    id: 0,
    name: 'analyze',
    title: 'analyze',
    description: 'Discover the affinity insights for your ideal audience.',
    defaultExample: `What motivates Cristiano Ronaldo's fans?`,
  },
  {
    id: 1,
    name: 'segmentation',
    title: 'segment',
    description: 'Analyze deep interest data to build personas',
    defaultExample: 'Unlock the nuances within the K-pop audience',
  },
  {
    id: 2,
    name: 'compare',
    title: 'compare',
    description: 'Expose business opportunities by comparing audiences.',
    defaultExample: 'Strategize how BMW can compete with Mercedes',
  },
];

const AudiencesOpenerContainer = ({
  userName,
  onItemDrop,
  overlapping = true,
}) => {
  return (
    <AudiencesOpeners
      apps={APPS}
      onItemDrop={onItemDrop}
      userName={userName}
      overlapping={overlapping}
    />
  );
};

export default AudiencesOpenerContainer;
